import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateSectionResult = { item: '_section' };
var _bulkCreateSectionsRequest = { sections: '_section' };
var _bulkCreateSectionsResponse = { results: '_bulkCreateSectionResult' };
var _bulkDeleteSectionsRequest = {};
var _bulkDeleteSectionsResponse = {};
var _bulkSectionResult = { section: '_section' };
var _bulkUpdateSectionRequest = { sections: '_maskedSection' };
var _bulkUpdateSectionResponse = { results: '_bulkSectionResult' };
var _cloneSectionsRequest = {};
var _cloneSectionsResponse = {};
var _createSectionRequest = { section: '_section' };
var _createSectionResponse = { section: '_section' };
var _deleteSectionRequest = {};
var _deleteSectionResponse = {};
var _duplicateSectionRequest = {};
var _duplicateSectionResponse = {};
var _getSectionRequest = {};
var _getSectionResponse = { section: '_section' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _listSectionsRequest = {};
var _listSectionsResponse = { sections: '_section' };
var _maskedSection = {
    mask: 'google.protobuf.FieldMask',
    section: '_section',
};
var _querySectionsRequest = {};
var _querySectionsResponse = { sections: '_section' };
var _section = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    image: '_image',
    additionalImages: '_image',
};
var _updateSectionRequest = {
    mask: 'google.protobuf.FieldMask',
    section: '_section',
};
var _updateSectionResponse = { section: '_section' };
function resolveComWixpressRestaurantsMenusSectionV1RestaurantsMenusSectionUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/sections',
                destPath: '/v1/sections',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/sections',
                destPath: '/v1/bulk/sections',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/sections',
                destPath: '/v1/sections',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/sections',
                destPath: '/v1/bulk/sections',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-menus-section',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/menus-section',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/sections',
                destPath: '/v1/bulk/sections',
            },
            {
                srcPath: '/restaurants/menus/v1/sections',
                destPath: '/v1/sections',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionRestaurantsDuplicateSectionUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/sections',
                destPath: '/v1/sections',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/sections',
                destPath: '/v1/bulk/sections',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/sections',
                destPath: '/v1/sections',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/sections',
                destPath: '/v1/bulk/sections',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-section',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-menus-section',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/menus-section',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/sections',
                destPath: '/v1/bulk/sections',
            },
            {
                srcPath: '/restaurants/menus/v1/sections',
                destPath: '/v1/sections',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function duplicateSection(payload) {
    var _a = serializer(_duplicateSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_duplicateSectionResponse, {}).fromJSON;
    function __duplicateSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.section',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_section.v1.restaurants_duplicate_section.RestaurantsDuplicateSection.DuplicateSection',
            url: resolveComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionRestaurantsDuplicateSectionUrl({ protoPath: '/v1/sections/{id}/duplicate', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __duplicateSection.fromReq = fromReq;
    __duplicateSection.__isAmbassador = true;
    return __duplicateSection;
}
/**
 * > **Note:** The Sections API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates a section.
 *
 * To create multiple sections at once, use [Bulk Create Sections](/sections/bulk-create-sections).
 */
export function createSection(payload) {
    var _a = serializer(_createSectionRequest, { _image: _image, _section: _section }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSectionResponse, {
        _image: _image,
        _section: _section,
    }).fromJSON;
    function __createSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.section',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.CreateSection',
            url: resolveComWixpressRestaurantsMenusSectionV1RestaurantsMenusSectionUrl({ protoPath: '/v1/sections', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSection.fromReq = fromReq;
    __createSection.__isAmbassador = true;
    return __createSection;
}
/**
 * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates multiple sections at once.
 */
export function bulkCreateSections(payload) {
    var _a = serializer(_bulkCreateSectionsRequest, { _image: _image, _section: _section }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateSectionsResponse, {
        _bulkCreateSectionResult: _bulkCreateSectionResult,
        _image: _image,
        _section: _section,
    }).fromJSON;
    function __bulkCreateSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.section',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.BulkCreateSections',
            url: resolveComWixpressRestaurantsMenusSectionV1RestaurantsMenusSectionUrl({ protoPath: '/v1/bulk/sections/create', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateSections.fromReq = fromReq;
    __bulkCreateSections.__isAmbassador = true;
    return __bulkCreateSections;
}
/**
 * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a section by ID.
 */
export function getSection(payload) {
    var _a = serializer(_getSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSectionResponse, {
        _image: _image,
        _section: _section,
    }).fromJSON;
    function __getSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.section',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.GetSection',
            url: resolveComWixpressRestaurantsMenusSectionV1RestaurantsMenusSectionUrl({ protoPath: '/v1/sections/{sectionId}', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSection.fromReq = fromReq;
    __getSection.__isAmbassador = true;
    return __getSection;
}
/**
 * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of up to 500 sections.
 */
export function listSections(payload) {
    var _a = serializer(_listSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSectionsResponse, {
        _image: _image,
        _section: _section,
    }).fromJSON;
    function __listSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.section',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.ListSections',
            url: resolveComWixpressRestaurantsMenusSectionV1RestaurantsMenusSectionUrl({ protoPath: '/v1/sections', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSections.fromReq = fromReq;
    __listSections.__isAmbassador = true;
    return __listSections;
}
/**
 * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of sections given the provided paging, filtering, and sorting. Up to 500 sections can be returned per request.
 *
 * For a detailed list of supported operations, see the [Supported Filters and Sorting](/sections/supported-filters-and-sorting) article. To learn how to query sections, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
 */
export function querySections(payload) {
    var _a = serializer(_querySectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_querySectionsResponse, {
        _image: _image,
        _section: _section,
    }).fromJSON;
    function __querySections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.section',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.QuerySections',
            url: resolveComWixpressRestaurantsMenusSectionV1RestaurantsMenusSectionUrl({ protoPath: '/v1/sections/query', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySections.fromReq = fromReq;
    __querySections.__isAmbassador = true;
    return __querySections;
}
/**
 * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates a section.
 *
 * Each time a section is updated, its revision increments by 1. The existing revision must be included when updating a section. This ensures you're working with the latest section information, and it prevents unintended overwrites.
 */
export function updateSection(payload) {
    var _a = serializer(_updateSectionRequest, { _image: _image, _section: _section }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSectionResponse, {
        _image: _image,
        _section: _section,
    }).fromJSON;
    function __updateSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.section',
            method: 'PATCH',
            methodFqn: 'com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.UpdateSection',
            url: resolveComWixpressRestaurantsMenusSectionV1RestaurantsMenusSectionUrl({ protoPath: '/v1/sections/{section.id}', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSection.fromReq = fromReq;
    __updateSection.__isAmbassador = true;
    return __updateSection;
}
/**
 * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates multiple sections at once.
 *
 * Each time a section is updated, its revision increments by 1. The existing revision must be included when updating a section. This ensures you're working with the latest section information, and it prevents unintended overwrites.
 */
export function bulkUpdateSection(payload) {
    var _a = serializer(_bulkUpdateSectionRequest, { _image: _image, _maskedSection: _maskedSection, _section: _section }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateSectionResponse, {
        _bulkSectionResult: _bulkSectionResult,
        _image: _image,
        _section: _section,
    }).fromJSON;
    function __bulkUpdateSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.section',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.BulkUpdateSection',
            url: resolveComWixpressRestaurantsMenusSectionV1RestaurantsMenusSectionUrl({ protoPath: '/v1/bulk/sections/update', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateSection.fromReq = fromReq;
    __bulkUpdateSection.__isAmbassador = true;
    return __bulkUpdateSection;
}
/**
 * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes a section.
 */
export function deleteSection(payload) {
    var _a = serializer(_deleteSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSectionResponse, {}).fromJSON;
    function __deleteSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.section',
            method: 'DELETE',
            methodFqn: 'com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.DeleteSection',
            url: resolveComWixpressRestaurantsMenusSectionV1RestaurantsMenusSectionUrl({ protoPath: '/v1/sections/{sectionId}', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSection.fromReq = fromReq;
    __deleteSection.__isAmbassador = true;
    return __deleteSection;
}
/**
 * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes multiple sections at once.
 */
export function bulkDeleteSections(payload) {
    var _a = serializer(_bulkDeleteSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteSectionsResponse, {}).fromJSON;
    function __bulkDeleteSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.section',
            method: 'DELETE',
            methodFqn: 'com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.BulkDeleteSections',
            url: resolveComWixpressRestaurantsMenusSectionV1RestaurantsMenusSectionUrl({ protoPath: '/v1/bulk/sections/delete', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteSections.fromReq = fromReq;
    __bulkDeleteSections.__isAmbassador = true;
    return __bulkDeleteSections;
}
/** Clone sections from a different metasite */
export function cloneSections(payload) {
    var _a = serializer(_cloneSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneSectionsResponse, {}).fromJSON;
    function __cloneSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.section',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.CloneSections',
            url: resolveComWixpressRestaurantsMenusSectionV1RestaurantsMenusSectionUrl({ protoPath: '/v1/sections/clone', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneSections.fromReq = fromReq;
    __cloneSections.__isAmbassador = true;
    return __cloneSections;
}
//# sourceMappingURL=http.impl.js.map